(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-video-testimonials]';

  function initializeCarousel(root) {
    if (root.hasAttribute('data-vtc-ready')) return;
    root.setAttribute('data-vtc-ready', 'true');

    var viewport = root.querySelector('[data-vtc-viewport]');
    var track = root.querySelector('[data-vtc-track]');
    var dots = root.querySelector('[data-vtc-dots]');
    var previousButton = root.querySelector('[data-vtc-prev]');
    var nextButton = root.querySelector('[data-vtc-next]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-vtc-slide]'));

    slides.sort(function (left, right) {
      return Number(right.getAttribute('data-vtc-order')) - Number(left.getAttribute('data-vtc-order'));
    });
    slides.forEach(function (slide) {
      track.appendChild(slide);
    });

    if (!slides.length) {
      root.hidden = true;
      return;
    }

    var index = 0;
    var slideWidth = viewport.clientWidth;
    var pointerStartX = 0;
    var pointerStartY = 0;
    var pointerIsDown = false;
    var pointerLock = null;
    var lockThreshold = 8;

    function loadVideo(slide) {
      var video = slide && slide.querySelector('video[data-vtc-src]');
      if (!video) return slide && slide.querySelector('video');

      video.src = video.getAttribute('data-vtc-src');
      video.removeAttribute('data-vtc-src');
      video.preload = 'metadata';
      video.load();
      return video;
    }

    function updatePosition() {
      track.style.transform = 'translate3d(' + (-index * slideWidth) + 'px, 0, 0)';
    }

    function updateState() {
      var dotButtons = dots.querySelectorAll('.vtc-dot');

      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === index;
        var video = slide.querySelector('video');
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (video) {
          video.tabIndex = active ? 0 : -1;
          if (!active) video.pause();
        }
      });

      Array.prototype.forEach.call(dotButtons, function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.setAttribute('aria-current', active ? 'true' : 'false');
        dot.setAttribute('aria-label', 'Go to testimonial ' + (dotIndex + 1) + ' of ' + slides.length);
        if (active) {
          dots.scrollLeft = Math.max(0, dot.offsetLeft - (dots.clientWidth - dot.clientWidth) / 2);
        }
      });
    }

    function goTo(newIndex, autoplay) {
      index = (newIndex + slides.length) % slides.length;
      updatePosition();
      updateState();

      var video = loadVideo(slides[index]);
      if (autoplay && video) video.play().catch(function () {});
    }

    slides.forEach(function (_, slideIndex) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'vtc-dot';
      dot.addEventListener('click', function () {
        goTo(slideIndex, true);
      });
      dots.appendChild(dot);
    });

    previousButton.addEventListener('click', function () {
      goTo(index - 1, true);
    });

    nextButton.addEventListener('click', function () {
      goTo(index + 1, true);
    });

    viewport.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(index + 1, true);
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(index - 1, true);
      }
      if (event.key === ' ') {
        event.preventDefault();
        var video = loadVideo(slides[index]);
        if (video) {
          if (video.paused) video.play().catch(function () {});
          else video.pause();
        }
      }
    });

    function isCarouselControl(target) {
      return Boolean(target.closest && (target.closest('.vtc-arrow') || target.closest('.vtc-dot')));
    }

    function commitThreshold() {
      return Math.min(80, slideWidth * 0.25);
    }

    viewport.addEventListener('pointerdown', function (event) {
      if (isCarouselControl(event.target) || event.button !== 0) return;
      pointerIsDown = true;
      pointerLock = null;
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
    });

    viewport.addEventListener('pointermove', function (event) {
      if (!pointerIsDown) return;

      var deltaX = event.clientX - pointerStartX;
      var deltaY = event.clientY - pointerStartY;

      if (pointerLock === null) {
        if (Math.abs(deltaX) < lockThreshold && Math.abs(deltaY) < lockThreshold) return;
        pointerLock = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';
        if (pointerLock === 'x') viewport.setPointerCapture(event.pointerId);
      }

      if (pointerLock === 'x') {
        event.preventDefault();
        track.style.transform = 'translate3d(' + (-index * slideWidth + deltaX) + 'px, 0, 0)';
      }
    });

    function endSwipe(event) {
      if (!pointerIsDown) return;
      pointerIsDown = false;

      if (pointerLock === 'x') {
        var deltaX = event.clientX - pointerStartX;
        if (Math.abs(deltaX) > commitThreshold()) goTo(deltaX < 0 ? index + 1 : index - 1, true);
        else updatePosition();
      }

      pointerLock = null;
    }

    viewport.addEventListener('pointerup', endSwipe);
    viewport.addEventListener('pointercancel', endSwipe);

    function resize() {
      slideWidth = viewport.clientWidth;
      updatePosition();
    }

    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(viewport);
    else window.addEventListener('resize', resize);

    updatePosition();
    updateState();

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        loadVideo(slides[0]);
        observer.disconnect();
      }, { rootMargin: '300px 0px' });
      observer.observe(root);
    } else {
      loadVideo(slides[0]);
    }
  }

  function initializeWithin(scope) {
    if (scope.matches && scope.matches(ROOT_SELECTOR)) initializeCarousel(scope);
    Array.prototype.forEach.call(scope.querySelectorAll(ROOT_SELECTOR), initializeCarousel);
  }

  function boot() {
    initializeWithin(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });
})();
